import BaseService from '@/services-ts/BaseService'
import type { ICompanySettings } from '@/types/Data'
import type { IPayloadCompanySetting } from '@/types/Request'

export default class LocationServices extends BaseService {
  GetLocationList() {
    return this.GET<ICompanySettings[]>(this.PATHS.GET_LOCATION_LIST)
  }

  CreateLocation(Name: string) {
    return this.POST<ICompanySettings>(this.PATHS.CREATE_LOCATION, { Name })
  }

  UpdateLocation(payload: IPayloadCompanySetting) {
    return this.POST<ICompanySettings>(this.PATHS.UPDATE_LOCATION, payload)
  }

  DeleteLocation(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_LOCATION, { Id })
  }
}
